import React from 'react';
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  Col
} from "reactstrap";

const Bulkmessaging = () => {
  const [singleSelect, setsingleSelect] = React.useState(null);
  return (
    <>
      <div className='content'>
      <Row>
      <Col md="12">
            <Card>
              
              
              <CardBody>
                <Form action="#">
                
                  <Row >
                    <Col md="6" sm='12'>
                   
                    <Label >Bulk Upload (<b>List of all mobile numbers (without 91) need to be in first column (A)</b>)</Label>
                    
                      <FormGroup>
                        <Input placeholder="placeholder" type="file" style={{"opacity" : "1", "position": "initial", "border" : "solid 1px #eee"}}/>
                      </FormGroup>
                    
                  
                    </Col>
                    <Col md="4" sm='12'>
                    <p className="category">Select Template</p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={singleSelect}
                          onChange={(value) => setsingleSelect(value)}
                          options={[
                            
                            { value: "1", label: "All" },
                            { value: "2", label: "Campaign Name" },
                            { value: "3", label: "Template Name" },
                            { value: "4", label: "Mobile NO" },
                            { value: "5", label: "Text Message" },
                            { value: "6", label: "Status" }
                          ]}
                          placeholder="Select"
                        />
                    </Col>
                    <Col md="2" sm='12'>
                    <Button className="btn-icon btn-primary btn mt-4" >
                  <i class="tim-icons icon-cloud-upload-94"></i>
                </Button>                               
                 
                   </Col>
                  </Row>
                </Form>
              </CardBody>
              
            </Card>
          </Col>
          </Row>
      </div>
    </>
  )
}

export default Bulkmessaging
